import 'svelte/internal/disclose-version';

Settings[$.FILENAME] = 'src/ui/Settings.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations(
	$.from_html(
		`
      <p class="error svelte-2duixxqt4m58u" id="settings-note" role="alert"> </p>
    `,
		1
	),
	Settings[$.FILENAME],
	[[42, 6]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
      <p class="note svelte-2duixxqt4m58u" id="settings-note">
        <!>
      </p>
    `,
		1
	),
	Settings[$.FILENAME],
	[[44, 6]]
);

var root_2 = $.add_locations(
	$.from_html(
		`

<button type="button" class="gear svelte-2duixxqt4m58u" aria-label="Settings" aria-haspopup="dialog">
  <svg viewBox="0 0 24 24" aria-hidden="true" class="svelte-2duixxqt4m58u">
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
</button>

<dialog closedby="any" aria-labelledby="settings-title" class="svelte-2duixxqt4m58u">
  <form method="dialog" class="svelte-2duixxqt4m58u">
    <h2 id="settings-title" class="svelte-2duixxqt4m58u">Settings</h2>
    <label class="option svelte-2duixxqt4m58u">
      <input type="checkbox" aria-describedby="settings-note" class="svelte-2duixxqt4m58u"/>
      <span>Skip Chinese → English and Chinese → Pinyin cards</span>
    </label>
    <!>
    <button class="done svelte-2duixxqt4m58u">Done</button>
  </form>
</dialog>

`,
		1
	),
	Settings[$.FILENAME],
	[
		[25, 0, [[26, 2, [[27, 4], [28, 4]]]]],
		[
			34,
			0,
			[[35, 2, [[36, 4], [37, 4, [[38, 6], [39, 6]]], [48, 4]]]]
		]
	]
);

export default function Settings($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Settings);

	let dialog = $.tag($.state(void 0), 'dialog');
	let box = $.tag($.state(void 0), 'box');

	// Restore the server state when a save fails.
	$.user_effect(() => {
		if (!$.get(box) || $$props.busy) return;

		$.get(box).checked = $.strict_equals($$props.paused, "all");
		$.get(box).indeterminate = $.strict_equals($$props.paused, "mixed");
	});

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_2();
	var button = $.sibling($.first_child(fragment));
	var dialog_1 = $.sibling(button, 2);
	var form = $.sibling($.child(dialog_1));
	var label = $.sibling($.child(form), 3);
	var input = $.sibling($.child(label));

	$.bind_this(input, ($$value) => $.set(box, $$value), () => $.get(box));
	$.next(3);
	$.reset(label);

	var node = $.sibling(label, 2);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var p = $.sibling($.first_child(fragment_1));
			var text = $.only_child(p);

			$.next();
			$.template_effect(() => $.set_text(text, `${$$props.error.detail ?? ''} ${$$props.error.hint ?? ''}`));
			$.append($$anchor, fragment_1);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_2 = root_1();
			var p_1 = $.sibling($.first_child(fragment_2));
			var node_1 = $.sibling($.child(p_1));

			{
				var consequent_1 = ($$anchor) => {
					var text_1 = $.text('Saving…');

					$.append($$anchor, text_1);
				};

				var consequent_2 = ($$anchor) => {
					var text_2 = $.text('Some sets skip them and some do not; checking skips them in all.');

					$.append($$anchor, text_2);
				};

				var alternate = ($$anchor) => {
					var text_3 = $.text('Applies to every set.');

					$.append($$anchor, text_3);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($$props.busy) $$render(consequent_1); else if ($.strict_equals($$props.paused, "mixed")) $$render(consequent_2, 1); else $$render(alternate, -1);
					}),
					'if',
					Settings,
					45,
					8
				);
			}

			$.next();
			$.reset(p_1);
			$.next();
			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($$props.error) $$render(consequent); else $$render(alternate_1, -1);
			}),
			'if',
			Settings,
			41,
			4
		);
	}

	$.next(3);
	$.reset(form);
	$.next();
	$.reset(dialog_1);
	$.bind_this(dialog_1, ($$value) => $.set(dialog, $$value), () => $.get(dialog));
	$.next();

	$.template_effect(() => {
		input.disabled = $$props.busy;
		$.set_attribute(input, 'aria-busy', $$props.busy);
	});

	$.delegated('click', button, function click() {
		return $.get(dialog)?.showModal();
	});

	$.delegated('change', input, function change(e) {
		return $$props.onchange(e.currentTarget.checked);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click', 'change']);
import "bun-svelte:Settings.svelte-2i8pnl7ac33rl-style.css";